import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import { StoreProvider } from './store/StoreProvider';
import { SubmitFeedbackProvider } from './components/store/SubmitFeedbackProvider';
import './styles/app.css';
import './styles/ileafs-theme.css';
import './styles/store-modals.css';

if (typeof window !== 'undefined') {
  window.addEventListener(
    'error',
    (event) => {
      const target = event.target as HTMLElement | null;
      if (target && target.tagName === 'IMG') {
        const img = target as HTMLImageElement;
        if (img.src && !img.dataset.fallbackApplied) {
          img.dataset.fallbackApplied = 'true';
          if (img.src.includes('/products/')) {
            img.src = '/assets/img/products/placeholder.svg';
          }
        }
      }
    },
    true,
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <StoreProvider>
        <SubmitFeedbackProvider>
          <App />
        </SubmitFeedbackProvider>
      </StoreProvider>
    </BrowserRouter>
  </StrictMode>,
);
